export default "__VITE_ASSET__AvcXxqKl__"